import type { OrdenDoc } from '@/datos/tipos';
import { repuestoAtrasado, type Repuesto } from './estado';

export const vistas = ['pendientes', 'atrasados', 'disponibles', 'todos'] as const;
export type Vista = (typeof vistas)[number];

export type FilaRepuesto = { orden: OrdenDoc; r: Repuesto; n: number };

export function filtrarRepuestos(ordenes: OrdenDoc[], ver: Vista, q: string, ahora: number) {
  const t = q.trim().toLowerCase();
  const tNorm = t.replace(/[^a-z0-9]/g, '');
  const filas: FilaRepuesto[] = [];
  for (const orden of ordenes) {
    (orden.repuestos ?? []).forEach((r, n) => {
      const ok =
        ver === 'todos' ||
        (ver === 'pendientes' && r.estado !== 'recibido') ||
        (ver === 'disponibles' && r.estado === 'recibido') ||
        (ver === 'atrasados' && repuestoAtrasado(r, ahora));
      const coincide =
        !t ||
        (tNorm && orden.patente.toLowerCase().includes(tNorm)) ||
        r.nombre.toLowerCase().includes(t) ||
        (r.proveedor ?? '').toLowerCase().includes(t);
      if (ok && coincide) filas.push({ orden, r, n });
    });
  }
  // Late first, then by expected date (no date last), then plate.
  return filas.sort(
    (a, b) =>
      Number(repuestoAtrasado(b.r, ahora)) - Number(repuestoAtrasado(a.r, ahora)) ||
      (a.r.llegada ?? '9999').localeCompare(b.r.llegada ?? '9999') ||
      a.orden.patente.localeCompare(b.orden.patente),
  );
}
